import utils from '@os-plugins/util.js';

export const state = () => ({
  data: {},
  level: 2,
  removeEmptyCat: false,
  activeBig: 0,
  activeSmall: 0,


});

var _state = utils.clearObject(state());

export const mutations = {
  clear(state) {
    state = Object.assign(state, {
      data: {},
      level: 2,
      removeEmptyCat: false,
      activeBig: 0,
      activeSmall: 0,
    });
  },
  update(state, data) {
    for (var key in data) {
      if (typeof state[key] !== 'undefined') {
        state[key] = data[key];
      }
    }
  },
  updateData(state, data) {
    for (var key in data) {
      if (typeof state.data[key] !== 'undefined') {
        state.data[key] = data[key];
      }
    }
  }
}

const P = 'products',
  K = '_key';
let B = 'bigCategory',
  S = 'smallCategory';

const createProKey = (pro) => {
  return pro.bigTypeId + "-" + pro.smallTypeId + "-" + pro.uid;
}

/**
 * 判断餐带大分类和小分类的字段名，如果字段名不为默认字段名则改变该字段名的方法
 * params data {Object} 餐单对象
 */
const changeMenuCategoryName = (data) => {
  if (!data[B] && data.bigs) {
    B = 'bigs';
    S = 'smalls';
  }
}

export const actions = {
  // init({commit},data){
  //  commit('update',{data});
  // },

  update({ commit }, data) {
    commit('update', data);
  },

  filterProduct({ commit, state }) {
    var activeBig = state.activeBig;
    var activeSmall = state.activeSmall;

    var temp_smalls = state.data[B].filter(big => big.parentId && activeBig == big.uid);

    if (state.level == 1 && temp_smalls.length) {

      var tempP = [];
      temp_smalls.forEach(small => {
        tempP = tempP.concat([], state.data[P].filter(pro => pro[K] == (small.parentId + "-" + small.uid + "-" + pro.uid)));
      });
      commit('updateData', {
        ["_" + P]: tempP
      })

    } else {
      commit('updateData', {
        ["_" + P]: state.data[P].filter(pro => pro[K] == (activeBig + "-" + activeSmall + "-" + pro.uid))
      })
    }
  },

  filterSmall({ commit, state, dispatch }, activeBig) {
    !activeBig && (activeBig = state.activeBig);
    let small = []; // 默认选择的小分类
    if (state.data[S]) { // 如果大分类和小分类分开的情况
      small = state.data[S].filter(small => small.parentId == activeBig);
    } else if (state.data[B].filter(item => item[S]).length) { // 如果大分类和小分类在一起的情况
      !state.data[S] && (state.data[S] = []);
      console.log(state.data[B].length)
      state.data[B].forEach(item => {
        if (Array.isArray(item[S])) { // 判断小分类是否存在
          state.data[S].push(...item[S]); // 把小分类添加到最外层数组
          let filterData = item[S].filter(small => small.parentId == activeBig);
          if (filterData.length) {
            small = filterData;
          }
        }
      });
    } else {
      state.data[S] = []; // 如果没有小分类则给默认值
    }
    console.log(small)
    commit('updateData', {
      ["_" + S]: small
    });

    if (!state.data["_" + S].length) {
      commit('update', {
        activeSmall: 0
      })
    } else {
      commit('update', {
        activeSmall: state.data["_" + S][0].uid
      });
    }

    dispatch('filterProduct');

  },

  reset({ commit, dispatch }) {},

  /**
   * 初始化菜单数据
   * @param {*} data 菜单数据
   * @param Number level 格式化后的菜单层级
   * @param Boolean removeEmptyCat 是否清除空的分类
   * @param Boolean init 是否进行初始化 暂时不用到
   * state -> data._products : [] 使用 booking.menu.filterProduct 将过滤当前分类的餐品结果
   * state -> data._products[i]._key : 'xx-xxx-xxxx' 餐品在购物车的唯一标识
   * state -> data._smallCategory : [] 使用 booking.menu.filterSmall 将过滤当前大分类的结果
   */
  init({ commit, dispatch, state }, { data = {}, level = 2, removeEmptyCat = false, init = true }) {
    if (!data || !data.menuId) {
      console.error("餐单数据异常|不能为空");
      return data;
    }
    changeMenuCategoryName(data);
    if (data[B]) { // 处理product bigTypeId smallTypeId失效问题
      data[B].forEach((cell) => {
        let bigTypeId = cell.uid;
        if (Array.isArray(cell[S])) {
          cell[S].forEach(item=> { // 小分类
            let smallTypeId = item.uid;
            if (Array.isArray(item.products)) {
              item.products.forEach(product=> {
                product.smallTypeId = smallTypeId;
                product.bigTypeId = bigTypeId;
                product.pid = product.uid;
              })
            }
          })
        }
        if (Array.isArray(cell.products)) { // 大分类
          cell.products.forEach(product=> {
            product.bigTypeId = bigTypeId;
            product.pid = product.uid;
          })
        }
      })
    }
    // ==== 同步到其他兄弟状态
    this.dispatch('booking/cart/init', {
      menuId: parseInt(data.menuId)
    });
    this.dispatch('booking/order/update', {
      menuId: parseInt(data.menuId)
    });
    if (data.surchargeRate) {
      this.dispatch('booking/cart/updateFee', {
        surchargeRate: data.surchargeRate
      });
    }
    // ====================

    data = utils.clearObject(data);

    commit('update', {
      level,
      removeEmptyCat,
    });
    if (removeEmptyCat) { // 开始找出并过滤掉空餐品数据的分类
      if (data[S]) {
        data[S] = data[S].filter(cat => (cat.products && cat.products.length));
      }
      // 分类显示层级对大分类的特殊处理
      if (level == 1) {
        data[B] = data[B].filter(cat => (cat.products && cat.products.length));
      } else {
        // 只清除没有二级分类且餐品数据为空的大分类
        let parentIds;
        if (data[S]) {
          parentIds = data[S].map(cat => cat.parentId);
        }
        data[B] = data[B].filter(cat => {
          const isProducts = !(cat.products && cat.products.length); // 该分类是否为空
          const isParentIds = parentIds && parentIds.indexOf(cat.uid) == -1; // 二级分类是否与一级分类分开
          const isCat = cat[S] && cat[S].parentId === cat.uid; // 二级分类是否在一级分类里面
          const isCat2 = !cat[S]; // 是否有二级分类
          // if (parentIds && parentIds.indexOf(cat.uid) == -1 && isProducts) {
          //   return false;
          // } else if (cat[S] && cat[S].parentId === cat.uid && isProducts) {
          //   return false;
          // } else if (!cat[S] && isProducts) {
          //   return false;
          // }
          return !((isCat || isParentIds || !cat[S]) && isProducts);
        });
      }

    }

    if (level == 1) { // 1级模式 打散二级分类到一级分类
      data[S] = data[S].map(small => {

        var parentIndex = data[B].findIndex(big => big.uid == small.parentId);
        if (parentIndex > -1) {
          data[B].splice(parentIndex, 1);
        }
        return small;

      });

      data[B] = data[B].concat([], data[S]);
      data[S] = [];

    }

    // 抽出全部餐品
    data[P] = [];
    const takeOutS = (big, uid) => { // 抽出二级分类
      big.forEach(small => {
        small[K] = small.parentId + "-" + small.uid;
        if (small.parentId == uid && small[P]) {
          data[P] = data[P].concat(small[P]);
          delete small[P];
        }
      });
    }
    data[B].forEach(big => {
      big[K] = big.uid;
      if (data[S]) { // 如果小分类在最外层
        takeOutS(data[S], big.uid);
      } else if (big[S]) { // 如果小分类在大分类里面
        takeOutS(big[S], big.uid);
      }
      // data[S].forEach(small=>{
      //  small[K] = small.parentId + "-" + small.uid;
      //  if(small.parentId == big.uid && small[P]){
      //    data[P] = data[P].concat(small[P]);
      //    delete small[P];
      //  }
      // });
      if (big[P]) {
        data[P] = data[P].concat(big[P]);
        delete big[P];
      }

    });



    data[P].forEach(pro => {
      pro[K] = createProKey(pro);
    });

    data["_" + S] = [];
    data["_" + P] = [];

    commit('update', {
      data
    });

    if (init) {

      //reset
      commit('update', {
        activeBig: 0,
        activeSmall: 0,
      });


      if (data[B].length) {
        commit('update', {
          activeBig: data[B][0].uid
        });
        dispatch('filterSmall');
      }
    }


  },
}



// WEBPACK FOOTER //
// ./../../store/booking/menu.js